import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Session } from '../../peer-colab-model/Session';
import { Lesson } from '../../peer-colab-model/PetKey/Main/Model/1_0_Initial/Backoffice/Training/Courses/Lessons/PathItems';
import { Course, Module } from '../../peer-colab-model/PetKey/Main/Model/1_0_Initial/Backoffice/Training/Courses/PathItems';
import AISuggestions from '../../components/AISuggestions';
import { CourseManagment } from '../../peer-colab-model/PetKey/BackofficeFE/Client/PathItems';

interface EditCourseToolbarProps {
  course: Course;
  module?: Module;
  lesson?: Lesson;
  onCourseClick?: () => void;
  onModuleClick?: () => void;
  onBack?: () => void;
  onAICompletion: () => void;
}

function EditCourseToolbar({ course, module, lesson, onCourseClick, onModuleClick, onBack, onAICompletion }: EditCourseToolbarProps) {
  const getUserLocation = () => {
    if (lesson) {
      return `The user is editing lesson "${lesson.name}" of module "${module?.name}" in course "${course.name}"`;
    }
    if (module) {
      return `The user is editing module "${module.name}" in course "${course.name}"`;
    }
    return `The user is editing course "${course.name}"`;
  };

  const getInstructionState = () => {
    let state = JSON.stringify(course);
    if (module) {
      state += '\n\nCurrent module id: ' + module.id;
    }
    if (lesson) {
      state += '\nCurrent lesson id: ' + lesson.id;
    }
    return state;
  }

  return (
    <AppBar position="static" color="default" elevation={1} sx={{ p:0, m: 0 }}>
      <Toolbar>
        {onBack && (
          <IconButton edge="start" color="inherit" onClick={onBack} sx={{ mr: 2 }}>
            <ArrowBackIcon />
          </IconButton>
        )}
        <Breadcrumbs aria-label="breadcrumb" sx={{ marginRight: 2 }}>
          <Link
            underline={onCourseClick ? 'hover' : 'none'}
            color="inherit"
            onClick={onCourseClick}
            sx={{ cursor: onCourseClick ? 'pointer' : 'default' }}
          >
            <Typography variant="h5" component="span">{course.name}</Typography>
          </Link>
          {module?.name && (
            <Link
              underline={onModuleClick ? 'hover' : 'none'}
              color="inherit"
              onClick={onModuleClick}
              sx={{ cursor: onModuleClick ? 'pointer' : 'default' }}
            >
              <Typography variant="h5" component="span">{module?.name}</Typography>
            </Link>
          )}
          {lesson?.name && (
            <Typography variant="h5" component="span" color="text.primary">{lesson?.name}</Typography>
          )}
        </Breadcrumbs>
        <AISuggestions 
          client={Session.getClient()}
          currentSnapshot={getInstructionState()}
          usageInstructions={CourseManagment.toAgentInstructions()}
          developerMessage={getUserLocation() + ' For any of the operations ' +
            'regarding a specific course the path parameter with the name courseId MUST be specified with that course id and if ' +
            'modifying a lesson the additional path parameter lessonId MUST also be specified with that lesson id.'}
          onOperationsApplied={onAICompletion}
        />
      </Toolbar>
    </AppBar>
  );
}

export default EditCourseToolbar;
